<nb-accordion multi class="custom-accordion mt-0">
  <!-- Réserves Section -->
  <nb-accordion-item [expanded]="reservesExpanded" (collapsedChange)="onReservesCollapsedChange($event)">
    <nb-accordion-item-header>
      <span class="text">{{ "site_control_reports.reserves" | translate }} ({{ reservations.length }})</span>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      @if (loadingReservations) {
        <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
      } @else {
        @if (!showAllStatuses && statusFilter === "active" && reservations.length > 0) {
          <div class="filter-info">
            <span>
              {{ "site_control_reports.active_filter" | translate }} (
              <span class="clear-link" (click)="onFilterInfoClick($event)">
                {{ "site_control_reports.clear_filter" | translate }}
              </span>
              )
            </span>
          </div>
        }

        @if (filteredReservations.length > 0) {
          <table class="table">
            <thead>
              <tr>
                <th class="align-middle">{{ "site_control_reports.reserve_label" | translate }}</th>
                <th class="align-middle" [class.active-filter]="!showAllStatuses && statusFilter === 'active'">
                  {{ "site_control_reports.status" | translate }}
                </th>
                <th class="align-middle">{{ "site_control_reports.issue_date" | translate }}</th>
                <th class="align-middle">{{ "site_control_reports.criticality" | translate }}</th>
                <th class="align-middle">{{ "site_control_reports.linked_equipment" | translate }}</th>
                <th class="align-middle">{{ "site_control_reports.responsible" | translate }}</th>
                <th class="align-middle">{{ "site_control_reports.close_date" | translate }}</th>
                <th class="align-middle"></th>
              </tr>
            </thead>
            <tbody>
              @for (reservation of filteredReservations; track reservation.id) {
                <tr>
                  <td class="align-middle">{{ reservation.label }}</td>
                  <td class="align-middle">
                    <nb-select
                      [selected]="reservation.status || ''"
                      (selectedChange)="onReservationStatusChange(reservation, $event)"
                      size="small"
                    >
                      <nb-option value="active">{{ "site_control_reports.status_active" | translate }}</nb-option>
                      <nb-option value="closed">{{ "site_control_reports.status_closed" | translate }}</nb-option>
                      <nb-option value="abandoned">{{ "site_control_reports.status_abandoned" | translate }}</nb-option>
                    </nb-select>
                  </td>
                  <td class="align-middle">{{ formatDate(reservation.issue_date || "") }}</td>
                  <td class="align-middle">
                    <span
                      class="criticality-text {{
                        getReservationCriticalityClass(reservation.criticality || '')
                      }}"
                    >
                      {{ getCriticalityLabel(reservation.criticality || "") }}
                    </span>
                  </td>
                  <td class="align-middle">{{ reservation.linked_equipment || "-" }}</td>
                  <td class="align-middle">{{ reservation.responsible || "-" }}</td>
                  <td class="align-middle">{{ formatDate(reservation.closing_date || "") }}</td>
                  <td class="align-middle">
                    <button class="btn btn-sm btn-outline-danger" (click)="openEditReservationDialog(reservation)">
                      <i class="fa-thin fa-pen-to-square"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <div class="empty-state">
            <div class="empty-message">{{ "site_control_reports.no_reserves" | translate }}</div>
          </div>
        }
      }
    </nb-accordion-item-body>
  </nb-accordion-item>

  <!-- Rapports bureau de contrôle Section -->
  <nb-accordion-item [expanded]="reportsExpanded" (collapsedChange)="onReportsCollapsedChange($event)">
    <nb-accordion-item-header>
      <span class="text">
        {{ "site_control_reports.control_reports" | translate }} ({{ reports.length }})
      </span>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      @if (reports.length > 0) {
        <table class="table">
          <thead>
            <tr>
              <th class="align-middle">{{ "site_control_reports.report_label" | translate }}</th>
              <th class="align-middle">{{ "site_control_reports.report_date" | translate }}</th>
              <th class="align-middle">{{ "site_control_reports.active_reserves_count" | translate }}</th>
              <th class="align-middle"></th>
              <th class="align-middle"></th>
            </tr>
          </thead>
          <tbody>
            @for (report of reports; track report.id) {
              <tr class="report-row" (click)="openEditReportDialog(report)">
                <td class="align-middle">{{ report.label }}</td>
                <td class="align-middle">{{ formatDate(report.date, false) }}</td>
                <td class="align-middle">{{ report.active_reservations_count || 0 }}</td>
                <td class="align-middle">
                  <button class="btn btn-sm btn-outline-danger" (click)="openEditReportDialog(report); $event.stopPropagation()">
                    <i class="fa-thin fa-pen-to-square"></i>
                  </button>
                </td>
                <td class="align-middle">
                  <button class="btn btn-sm btn-outline-danger" (click)="deleteReport(report); $event.stopPropagation()">
                    <i class="fa-thin fa-trash-can"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="empty-state">
          <div class="empty-message">{{ "site_control_reports.no_reports" | translate }}</div>
        </div>
      }

      <div class="add-objective-container">
        <a class="add-objective-button" (click)="openAddReportDialog()">
          (+)
          <span>{{ "site_control_reports.add_report" | translate }}</span>
        </a>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
